import Image from 'next/image';
import { motion } from 'framer-motion';

import { cn } from '#/lib/utils';

import AdobeExperiencePlatformLogo from './icons/adobe.svg';
import algonomy from './icons/algonomy.svg';
import braze from './icons/braze.svg';
import HubspotLogo from './icons/hubspot.svg';
import IntercomLogo from './icons/intercom.svg';
import mParticleLogo from './icons/mParticle.svg';
import salesforce from './icons/salesforce.svg';
import sendgrid from './icons/sendgrid.svg';
import snowflake from './icons/snowflake.svg';
import twilio from './icons/twilio-icon.svg';
import { defaultMotionProps } from './motion';

const logos = [
  {
    title: 'Hubspot',
    isNew: true,
    logo: HubspotLogo,
  },
  {
    title: 'Intercom',
    isNew: true,
    logo: IntercomLogo,
  },
  {
    title: 'Adobe Experience Platform',
    isNew: true,
    logo: AdobeExperiencePlatformLogo,
  },
  {
    title: 'mParticle',
    isNew: true,
    logo: mParticleLogo,
  },
  {
    title: 'Algonomy',
    isNew: true,
    logo: algonomy,
  },

  {
    title: 'Snowflake',
    isNew: true,
    logo: snowflake,
  },
  {
    title: 'Salesforce',
    logo: salesforce,
    badgeText: '3x Honoree',
  },
  {
    title: 'Sendgrid',
    badgeText: 'returning honoree',
    logo: sendgrid,
  },
  {
    title: 'Braze',
    logo: braze,
    isNew: false,
    badgeText: 'Returning honoree',
  },
  {
    title: 'Twilio',
    logo: twilio,
    isNew: false,
    badgeText: 'Returning honoree',
  },
];

export const LogoStack = () => {
  return (
    <motion.section
      className="@container/wrapper"
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, margin: '-150px' }}
      transition={{ duration: 0.5, delay: 0.3 }}
      variants={{
        animate: {
          transition: {
            staggerChildren: 0.1,
          },
        },
      }}
    >
      <div className="grid grid-cols-1 @[450px]/wrapper:grid-cols-2 gap-16">
        {logos.map(({ logo, title, isNew, badgeText }) => (
          <motion.div
            key={title}
            className={cn(
              'bg-cloud p-16 rounded-16 flex justify-between flex-row items-center @[450px]/wrapper:flex-col @[450px]/wrapper:items-start',
            )}
            variants={{
              initial: {
                opacity: 0,
                y: 10,
              },
              animate: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={defaultMotionProps.transition}
          >
            <div className="flex items-center gap-12 @[450px]/wrapper:gap-16">
              <Image
                src={logo}
                alt={`${title} logo`}
                className="size-26 @[450px]/wrapper:size-40 "
              />
              <span className="text-12 m:text-14 l:text-16 font-normal leading-100 text-[#000]">
                {title}
              </span>
            </div>
            {(isNew || badgeText) && (
              <span
                className={cn(
                  'text-[10px] @[450px]/wrapper:text-12 font-normal leading-150 bg-amethyst-02 @[450px]/wrapper:mt-16 px-16 py-6 uppercase text-charcoal rounded-full block w-max h-max whitespace-nowrap',
                  isNew ? 'bg-amethyst-02' : 'bg-grayscale-02',
                )}
              >
                {isNew ? '1st TIME HONOREE' : badgeText}
              </span>
            )}
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};
